<script setup lang="ts">
const pageStore = usePageStore();
</script>

<template>
  <div id="default-layout" class="flex min-h-screen flex-col">
    <AccessibilityBar />
    <AppHeader :key="pageStore.headerType" />
    <main class="relative flex grow flex-col items-center">
      <slot />
    </main>

    <AppFooter />
  </div>
</template>
